package br.com.texeratx.boardgametimeapp.ui.screens.matches.model

import br.com.texeratx.boardgametimeapp.data.model.match.MatchListItemDTO

fun MatchListItemDTO.toUI() = MatchListItemUI(
    id = id,
    date = date,
    duration = duration,
    game = MatchGameUI(
        id = game.id,
        name = game.name,
        imageUrl = game.imageUrl
    ),
    players = players.map {
        MatchPlayerUI(
            id = it.id,
            name = it.name,
            nickname = it.nickname,
            imageUrl = it.imageUrl,
            points = it.points
        )
    },
    expansionIds = clanExpansionIds
)
